import script from "./LegalView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegalView.vue?vue&type=script&setup=true&lang=ts"

import "./LegalView.vue?vue&type=style&index=0&id=fffc72b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fffc72b6"]])

export default __exports__